/* eslint-disable max-len */
import type { TMessages } from '@/types/TMessages'

export const messages = {
  header: {
    title: 'Сопровождение, консультирование и семинары для фермеров по ЕФИС ЗСН',
    actionButton: 'Запросить консультацию',
    description:
      'Начиная с 01.01.2024 необходимо регистрировать поля в ЕФИС ЗСН (Единой федеральной информационной системе земельных участков) для того, чтобы во ФГИС «Зерно» корректно отображались данные о собранном урожае зерна в привязке к земельным участкам (полям)',
  },
  learn: {
    title: 'Обучающие семинары и онлайн-курсы по ЕФИС ЗСН',
    list: {
      item1: 'Как получить учетную запись;',
      item2: 'Как найти перечень своих полей;',
      item3: 'Как найти поле на карте;',
      item4: 'Порядок просмотра характеристик поля;',
      item5: 'Порядок внесения данных по севообороту;',
      item6: 'Основные виды отчетов, доступные в ЕФИС ЗСН;',
      item7: 'Порядок работы в части внесения данных для ФГИС «Зерно».',
    },
  },
  solution: {
    title: 'Какие задачи решает Аналитический центр лесного и сельского хозяйства?',
    list: {
      item1: 'Комплекс услуг по ЕФИС ЗСН и ФГИС Зерно;',
      item2:
        'Услуги по анализу состояния и использования земельных участков на землях. Результат - отчет о земельном участке от состава земель до возможностей урожайности, с рекомендациями по планированию севооборота с просчитанным результатом;',
      item3:
        'Подготовка карт на основе спутниковых данных и агрохимических служб по анализу почв (1) для расчета использования удобрения и потенциальной урожайности и (2) для оптимального выбора культур для посева.',
    },
  },
  faq: {
    title: 'Вопросы и ответы',
    list: {
      item1: {
        question: 'Что такое ЕФИС ЗСН и какова ее цель?',
        answer: {
          p1: 'ЕФИС ЗСН — информационная система, предназначенная для обеспечения актуальными и достоверными сведениями о землях сельскохозяйственного назначения (ЗСН), включая данные об их местоположении, состоянии и фактическом использовании.',
          p2: 'Цель создания системы — осуществление государственного мониторинга использования и состояния ЗСН, плодородия земель сельхозугодий, использования и состояния мелиоративных систем и гидротехнических сооружений, состояния сельхозкультур и др.',
          p3: 'Система автоматизирует процессы сбора, накопления, обработки, анализа и предоставления информации, связанные c систематическим наблюдением за состоянием и использованием земель сельскохозяйственного назначения.',
        },
      },
      item2: {
        question: 'Что включено в стоимость курса / семинара?',
        answer: {
          p1: 'Оплаченный курс доступен для слушателей в течении 30 дней после оплаты.',
          p2: 'В этот же период слушателям оказывается бесплатная расширенная техническая поддержка.',
        },
      },
    },
  },
  benefits: {
    title: 'Получение напрямую экспертизы от профессионалов системы ЕФИС ЗСН – экономия Вашего времени',
    list: {
      item1: 'Полное сопровождение и контроль за аккаунтами в системах ЕФИС ЗСН позволит вам сфокусироваться на вашем бизнесе',
      item2:
        'Данные услуги помогут вам избежать штрафов, связанных с нарушением комплекса требований по ведению данных в ЕФИС ЗСН и ФГИС Зерно',
      item3: 'Наши специалисты помогут вам получить актуальную карту Вашего хозяйства',
    },
  },
  form: {
    title: 'Оформите заявку',
    description: 'Мы подробнее расскажем о возможностях платформы и ответим на вопросы',
    button: 'Оформить заявку',
  },
  fieldEvaluationReportDialog: { comment: 'Заявка на отчет из ЕФИС ЗСН' },
} satisfies TMessages
